import { g as n } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as l, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconHand",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = n();
  }
}, _ = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], h = /* @__PURE__ */ a("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.94.94a1.5 1.5 0 0 1 2.324.253 1.5 1.5 0 0 1 2.183.913A1.5 1.5 0 0 1 11.5 3.5V7A4.5 4.5 0 0 1 7 11.5H6c-1.534 0-2.51-.484-3.347-1.315l-.002-.001-1.8-1.8A1.5 1.5 0 0 1 2.5 5.966V2.5a1.5 1.5 0 0 1 2.236-1.307 1.5 1.5 0 0 1 .203-.254ZM4.5 2.5v2.75a.5.5 0 0 0 1 0V2a.5.5 0 1 1 1 0v3a.5.5 0 0 0 1 0V2.5a.5.5 0 1 1 1 0v3a.5.5 0 0 0 1 0v-2a.5.5 0 1 1 1 0V7A3.5 3.5 0 0 1 7 10.5H6c-1.265 0-1.99-.376-2.642-1.024L1.569 7.687a.5.5 0 0 1 .707-.704l.37.37.5.5a.5.5 0 1 0 .708-.707L3.5 6.793V2.5a.5.5 0 1 1 1 0Z",
  "clip-rule": "evenodd"
}, null, -1), f = [
  h
], p = ["id"], m = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  m
];
function g(e, I, d, b, q, t) {
  return l(), r("svg", {
    "aria-label": d.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--hand"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Hand",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, f, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, p)
    ])
  ], 10, _);
}
const A = /* @__PURE__ */ s(c, [["render", g]]);
export {
  A as default
};
//# sourceMappingURL=hand.js.map
